/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { CLIENT } from 'actions/signup';

import { requestCode as requestCodeAction } from 'actions/user';

import StepHeader from 'components/StepHeader/StepHeader';
import Form from 'components/Form/Form';

/**
 * This is the RequestCode component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class RequestCode extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {Object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    user: shape({
      firstname: string.isRequired,
    }).isRequired,
    signup: shape({
      type: string.isRequired,
    }).isRequired,
    requestCodeForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    requestCode: func,
  };

  /**
   * Trigger request code action.
   *
   * @param {Object} data
   * @param {string} data.phone_number
   */
  requestCode = data => {
    const {
      auth: { token },
      requestCode,
    } = this.props;

    requestCode(token, data);
  };

  /**
   * Render RequestCode.
   *
   * @return {Object}
   */
  render() {
    const {
      user: { firstname: name },
      signup,
      requestCodeForm,
    } = this.props;
    const tagline = name
      ? p.t('signup.request_code.hello_with_name', { name })
      : p.t('signup.request_code.hello_no_name');

    return (
      <article>
        <StepHeader
          tagline={tagline}
          title={p.t('signup.request_code.title')}
          description={p.t('signup.request_code.description')}
          current={2}
          total={signup.type === CLIENT ? 7 : 6}
        />
        <section>
          <Form {...requestCodeForm} onSubmit={this.requestCode} />
        </section>
      </article>
    );
  }
}

export default withRouter(
  connect(
    ({ auth, user, signup, requestCodeForm }) => ({
      auth,
      user,
      signup,
      requestCodeForm,
    }),
    {
      requestCode: requestCodeAction,
    }
  )(RequestCode)
);
